var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.3 22.6"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 255",
    d: "M16.49 2.57V4h2.24a2.57 2.57 0 012.57 2.55V20a2.57 2.57 0 01-2.57 2.56H7.38A2.57 2.57 0 014.81 20v-3H2.57A2.57 2.57 0 010 14.45V2.57A2.57 2.57 0 012.57 0h11.35a2.56 2.56 0 012.56 2.56zM14.54 4V2.57a.62.62 0 00-.62-.57H2.57a.62.62 0 00-.57.57v11.88a.62.62 0 00.62.62h2.19V6.56A2.58 2.58 0 017.38 4h7.16zm4.81 16V6.55a.64.64 0 00-.62-.62H7.38a.64.64 0 00-.62.63V20a.62.62 0 00.62.62h11.35a.62.62 0 00.62-.62z",
    fill: "#757575",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 909",
    x: 6.65,
    y: 5.3,
    width: 13,
    height: 16,
    rx: 1,
    fill: "#d8d8d8"
  })))));
}
export default SvgCopyFill;